module.exports = __webpack_public_path__ + "img/cptgb-3-en.c29f7fcd.png";